'use strict'

require('./helpers/breakpoints')
require('./helpers/lazy-load')
require('./helpers/preloader')
require('./helpers/popups')
require('./helpers/cookies')
require('./helpers/header')
require('./helpers/navigation')
require('./helpers/custom-select')
require('./helpers/cursor')

require('./setup')
require('./locomotive-scroll')

require('./global_events')

require('./sections/first')
require('./sections/logo-slider')
require('./sections/explore-slider')






